<template>
  <div class="alert" v-if='message && action'>
    <div class="alert__backdrop"></div>
    <div class="alert__content">
      <div class="alert__message" v-html='message'></div>
      <button class='btn btn-danger' type='button'
        v-if='cancelAction' @click='handleCancel' >
        {{ cancelText || "キャンセル" }}
      </button>
      <button class='btn' type='button' 
        v-if='action' @click='handleAction'>
        {{ actionText || "Ok"}}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Alert',
  data: function() {
    return {
      message: '',
      action: null,
      cancelAction: null,
      actionText: '',
      cancelText: '',
    }
  },
  methods: {
    reset: function() {
      this.message = '';
      this.action = null;
    },
    handleCancel: function() {
      if (this.cancelAction) this.cancelAction();
      this.reset();
    },
    handleAction: function() {
      if (this.action) this.action();
      this.reset();
    },
    update: function(params) {
      this.message = params.message || '';
      
      this.actionText = params.actionText || '';
      this.cancelText = params.cancelText || '';

      this.action       = params.action;
      this.cancelAction = params.cancelAction;
    }
  },
  created: function() {
    this.$$.alert = this.update.bind(this);
  }
}
</script>
<style lang='scss'>
.alert {
  font-size: 16px;
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 16px;
  &__backdrop {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.5);
    transiton: all .2s ease;
  }
  &__content {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    padding: 16px;
    max-width: 360px;
    margin: 0 auto;
    border-radius: 3px;
    border: 1px solid #fad8d8;
    text-align: center;
    background: #faf9f9;
    transform: translateY(-50%);
  }
  &__message {
    color: #fa5555;
    font-size: 1.2em;
    margin-bottom: 1em;
  }
  .btn {
    margin: .5em;
  }
}
</style>